import utils from 'blue-utils';

const getters = {
  isLogin(state) {
    return utils.isPlainObject(state.userInfo);
  }
};

export default getters;

